import React, { useState } from 'react';

function ViewOrderAndDetail({ vendor, closeModal }) {
  const [showDocumentModal, setShowDocumentModal] = useState(false);

  if (!vendor) return null;

  const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    return {
      date: date.toLocaleDateString(),
      time: date.toLocaleTimeString(),
    };
  };

  const { date, time } = formatDateTime(vendor?.createdAt);

  return (
    <div className="modeldesignnew">
      <div className="overlaydesign"></div>
      <div
        className="modal fade viewbox edit-box show d-block"
        id="manufacturerModal"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Offer & Deal Details</h5>
              <button
                type="button"
                className="btn-close"
                onClick={closeModal}
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              <div className="vendor-container">
                {/* Basic Details */}
                <div className="card shadow-sm border-0 rounded-3 mb-1">
                  <div className="card-header">
                    <h6>
                      <i className="bi bi-info-circle"></i> Offer Details
                    </h6>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        <strong>Title:</strong> {vendor?.title || 'N/A'}
                      </div>
                      <div className="col-md-6">
                        <strong>SubTitle:</strong> {vendor?.subtitle || 'N/A'}
                      </div>
                      <div className="col-md-6">
                        <strong>Sequence:</strong> {vendor?.sequence ?? 'N/A'}
                      </div>
                      <div className="col-md-6">
                        <strong>Status:</strong> {vendor?.status || 'N/A'}
                      </div>
                      <div className="col-md-6">
                        <strong>Created:</strong> {date} {time}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Document / Image */}
                <div className="vendor-container mt-3">
                  <div className="card shadow-sm border-0 rounded-3 mb-1">
                    <div className="card-header">
                      <h6>
                        <i className="bi bi-image"></i> Image
                      </h6>
                    </div>
                    <div className="card-body">
                      <div className="document-section mt-2 d-flex">
                        <button
                          className="document-update-btn"
                          onClick={() => setShowDocumentModal(true)}
                          disabled={!vendor?.image}
                        >
                          <img
                            src="img/label-img.svg"
                            alt="Document"
                            className="me-1"
                          />
                          View Image
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Image Modal */}
        {showDocumentModal && vendor?.image && (
          <div
            className="modal fade show d-block"
            id="imguploadModal"
            tabIndex={-1}
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Image</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowDocumentModal(false)}
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="container-box px-5">
                    <div className="container-box-inner table-reponsive-tabe">
                      <img
                        src={`${process.env.REACT_APP_URL}${vendor.image}`}
                        alt="Offer"
                        style={{
                          width: '350px',
                          height: '220px',
                          display: 'block',
                          marginInline: 'auto',
                          objectFit: 'contain',
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ViewOrderAndDetail;